import LoanInterface from "@/types_and_interfaces/loan_interface.ts";
import React from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import CommonClass from "@/utils/common.ts";
import DashboardClass from "@/utils/dashboard_class.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import clsx from "clsx";
import st from "@/styles/CreditPage.module.scss";
import Skeleton from "@mui/material/Skeleton";
import Button from "@/ui/Button.tsx";

interface PayProps {
    credit: LoanInterface | undefined
    mobile?: boolean
}

const Pay:React.FC<PayProps> = ({credit, mobile}) => {
    const {t} = useTranslation()
    const navigate = useNavigate()

    const pay_funct = (all?:string) => {
        if(window.innerWidth > CommonClass.breakpoints.breakpoint2) {
            navigate(DashboardClass.dashboard_routes.Banks+"/" + credit?.urn + "/" + all || "0")
        } else {
            eventEmitter.emit(CommonClass.ModalEvents.PayCreditModalOpen, {credit, all})
        }
    }
    
    return (credit?.r_status_simplified === "success" && credit?.r_status !== "settled" && (Number(credit?.inst_amount) > 0 || Number(credit?.disc_amount ) > 0)) && (
        <div className={clsx(st.column_right, mobile ? st.mobile : st.desktop)}>
            
            {credit?.restant_days ? (
                <span className={st.danger}>
                    {t("restant").replace("{{days}}", String(credit?.restant_days)) + t(CommonClass.time_word_handling(credit?.restant_days))}
                </span>
            ) : null}
            
            <span>
                {t("to_pay")}
            </span>
            
            {(Number(credit?.disc_amount ) > 0 || Number(credit?.inst_amount) > 0) ? (
                <strong
                    className={clsx(st.amount, credit?.restant_days > 0 && st.danger)}
                >
                    {CommonClass.formatMoneyAmount(Number(credit?.inst_amount)) + " " + t("currency")}
                </strong>
            ) : (
                <Skeleton
                    variant="rectangular"
                    sx={{
                        alignItems: "flex-end",
                        width: "100%",
                        borderRadius:"10px",
                        minHeight: "50px",
                        bgcolor: "#eeeeee"
                    }}
                />
            )}
            
            <div className={st.controllers}>
                
                <Button
                    onClick={() => pay_funct("0")}
                    className={st.button_pay}
                >
                    {t("pay")}
                </Button>
                
                <Button
                    outlined
                    className={st.anticipat_pay}
                    onClick={() => pay_funct("1")}
                >
                    {t("anticipat_pay")}
                    <br/>
                    {CommonClass.formatMoneyAmount(Number(credit?.disc_amount)) + " " + t("currency")}
                </Button>
            
            </div>
        
        
        </div>
    )
}

export default Pay